import React, { useEffect } from 'react';
import { ThemeProvider } from '@uhg-abyss/web/ui/ThemeProvider';
import { OverlayProvider } from '@uhg-abyss/web/ui/OverlayProvider';
import { createTheme } from '@uhg-abyss/web/tools/theme';
import APP_CONSTANT from './constant';
import CommonAppHeaderContent from './CommonAppHeaderContent/CommonAppHeaderContent';
import { HeaderBanner } from './HeaderBanner/HeaderBanner';
import { SiteNotifications } from './SiteNotifications/SiteNotifications';
import { ProviderBanner } from '@src/apps/ProviderBanner/ProviderBanner';

const theme = createTheme('uhc', APP_CONSTANT?.themeOverride);
theme.themeVariantFonts!();

export const CommonAppHeader = ({ notificationContextKey }: { notificationContextKey?: string }) => {
    useEffect(() => {
        window.dispatchEvent(new CustomEvent('parcelLoad'));
    }, []);

    return (
        <ThemeProvider theme={theme} includeBaseCss={APP_CONSTANT?.includeBaseCss}>
            <OverlayProvider data-testid="overlay-provider">
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <ProviderBanner />
                    <SiteNotifications key={notificationContextKey} />
                    <HeaderBanner />
                    <CommonAppHeaderContent />
                </div>
            </OverlayProvider>
        </ThemeProvider>
    );
};
